/*** IMPORTS FROM imports-loader ***/
var define = false;

var getBuiltIn = require('../internals/get-built-in');

module.exports = getBuiltIn('navigator', 'userAgent') || '';

